import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import { Link } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import Select from "react-select";

//needs
import Web3 from "web3";
import * as utils from "web3-utils";
import network from "../../lib/AdminNetwork";
import { useDispatch, useSelector } from "react-redux";
import { ServiceFeeaction } from "../../actions/users";
import { toast } from "react-toastify";
import config from "../../lib/config";
import Market from "../../ABI/market.json";
import { Account_Connect } from "../../actions/redux/action";
import { isEmpty } from "../../actions/commonFunction";
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import {
  networkForChainId,
  nextAdminNetwork,
  normalizeChainId,
  readProviderChainId,
  switchProviderNetwork,
} from "../../lib/walletNetwork";

let toasterOption = config.toasterOption;

const ServiceFeeEdit = () => {
  const dispatch = useDispatch();
  const Wallet_Details = useSelector((state) => state.wallet_connect_context);

  const [Accounts, Set_Accounts] = useState("");
  const [owner_Get, set_Owner_Get] = useState("");
  const [contractReadError, setContractReadError] = useState("");

  const [modalOpen, setmodalopen] = useState(false);

  const [ServiceDisable, setServiceDisable] = useState("start");
  const [ServiceDisable1, setServiceDisable1] = useState("init");
  const [ServiceDisable2, setServiceDisable2] = useState("init");
  const [ServiceDisable3, setServiceDisable3] = useState("init");
  const [seller__fee, set_seller__fee] = useState(0);
  const [buyer__fee, set_buyer__fee] = useState(0);
  const [minting_fee, set_minting_fee] = useState(0);
  const [listing__fee, set_listing__fee] = useState(0);
  const [withdraw__fee, set_withdraw__fee] = useState(0);
  const [ServiceFeeOptions, SetServiceFeeOption] = useState([]);
  const [SelectedServiceFee, SetSelectedServiceFee] = useState({});

  const [currentChainId, SetCurrentChainId] = useState("");

  const [submitdisable, SetSubmitDisable] = useState(false);

  const [web3Provider, setWeb3Provider] = useState("");

  const options = [
    { value: "default collections", label: "Default Collections" },
    { value: "book collections", label: "Book Collections" },
    { value: "audio collections", label: "Audio Collections" },
    { value: "video collections", label: "Video Collections" },
  ];
  const [selectOption, setSelectOption] = useState("Default Collections");

  useEffect(() => {
    if (
      localStorage.getItem(config.adminWalletAddressKey) &&
      localStorage.getItem(config.walletType) == "walletConnect"
    ) {
      getConnect();
    }
    if (
      localStorage.getItem(config.adminWalletAddressKey) &&
      localStorage.getItem(config.walletType) == "metamask"
    ) {
      getMetamask();
    }
    GetServiceFeeOrder();
    const configuredChainId = normalizeChainId(
      Wallet_Details.networkConfiguration.Chainid,
    );
    if (configuredChainId !== null) SetCurrentChainId(configuredChainId);
  }, [
    Wallet_Details.UserAccountAddr,
    Wallet_Details.networkConfiguration.Chainid,
  ]);

  useEffect(() => {
    const storedAccount = localStorage.getItem(config.adminWalletAddressKey);
    if (!Wallet_Details.UserAccountAddr && !storedAccount) return undefined;
    const provider = Wallet_Details.providerss
      || (typeof window !== "undefined" ? window.ethereum : null);
    if (!provider || typeof provider.request !== "function") return undefined;

    let active = true;
    const syncNetwork = async (rawChainId) => {
      try {
        const chainId = rawChainId === undefined
          ? await readProviderChainId(provider)
          : normalizeChainId(rawChainId);
        if (!active || chainId === null) return;
        SetCurrentChainId(chainId);

        const networkConfiguration = networkForChainId(chainId, network);
        if (!networkConfiguration) {
          set_Owner_Get("");
          set_buyer__fee("");
          set_seller__fee("");
          set_minting_fee("");
          set_listing__fee("");
          set_withdraw__fee("");
          setContractReadError(
            `Unsupported wallet network (${chainId}). Switch to Ethereum or BNB Smart Chain.`,
          );
          return;
        }

        setContractReadError("");
        const account = Wallet_Details.UserAccountAddr || storedAccount;
        const web3 = new Web3(provider);
        dispatch({
          type: Account_Connect,
          Account_Detail: {
            UserAccountAddr: account,
            WalletConnected: "true",
            Accounts: account,
            providerss: provider,
            networkConfiguration,
            web3,
          },
        });
      } catch (error) {
        if (active) {
          setContractReadError(
            error?.message || "Unable to read the connected wallet network.",
          );
        }
      }
    };

    syncNetwork();
    const handleChainChanged = (chainId) => syncNetwork(chainId);
    provider.on?.("chainChanged", handleChainChanged);
    return () => {
      active = false;
      provider.removeListener?.("chainChanged", handleChainChanged);
    };
  }, [
    Wallet_Details.providerss,
    Wallet_Details.UserAccountAddr,
    dispatch,
  ]);

  useEffect(() => {
    if (!localStorage.getItem(config.adminWalletAddressKey)) {
      toast.error("Please connect wallet");
    }
  }, []);

  const getConnect = async () => {
    try {
      let wcProvider = await EthereumProvider.init({
        projectId: config.walletConnectProjectId,
        chains: [network.ETH.Chainid, network.BSC.Chainid],
        optionalChains: [network.ETH.Chainid, network.BSC.Chainid],
        showQrModal: true, // Shows QR code scan popup
        metadata: {
          name: "Edaface",
          description: "Edaface NFT MarketPlace",
          url: config.marketplaceUrl,
          icons: config.marketplaceIconUrl ? [config.marketplaceIconUrl] : [],
        },
      });
      if (!wcProvider.session) {
        await wcProvider.connect();
      }
      // 3. Wrap with Web3.js
      const web3Instance = new Web3(wcProvider);
      setWeb3Provider(wcProvider);
      const connectedChainId = await readProviderChainId(wcProvider);
      const configdata = networkForChainId(connectedChainId, network);
      const accounts = await web3Instance.eth.getAccounts();
      const setacc = accounts?.[0]?.toLowerCase();
      if (!setacc) throw new Error("The wallet did not return a connected account");

      Set_Accounts(setacc);
      SetCurrentChainId(connectedChainId);
      if (!configdata) {
        setContractReadError(
          `Unsupported wallet network (${connectedChainId}). Use Switch Network to select BNB Smart Chain.`,
        );
      }

      localStorage.setItem(config.adminWalletAddressKey, setacc);
      localStorage.setItem(config.walletType, "walletConnect");

      dispatch({
        type: Account_Connect,
        Account_Detail: {
          UserAccountAddr: setacc,
          WalletConnected: "true",
          Accounts: setacc,
          providerss: wcProvider,
          networkConfiguration: configdata || {},
          web3: web3Instance,
        },
      });
    } catch (errr) {
      console.error("getConnect_error", errr);
      toast.error(errr?.message || "Unable to connect the mobile wallet");
    }
  };

  const getMetamask = async () => {
    try {
      const provider = typeof window !== "undefined" ? window.ethereum : null;
      if (!provider || typeof provider.request !== "function") {
        throw new Error("No compatible browser wallet was found");
      }

      await provider.request({ method: "eth_requestAccounts" });
      const web3 = new Web3(provider);
      const connectedChainId = await readProviderChainId(provider);
      const configdata = networkForChainId(connectedChainId, network);
      const accounts = await web3.eth.getAccounts();
      const setacc = accounts?.[0]?.toLowerCase();
      if (!setacc) throw new Error("The wallet did not return a connected account");

      Set_Accounts(setacc);
      SetCurrentChainId(connectedChainId);
      setWeb3Provider(provider);
      if (!configdata) {
        setContractReadError(
          `Unsupported wallet network (${connectedChainId}). Use Switch Network to select BNB Smart Chain.`,
        );
      } else {
        setContractReadError("");
      }

      localStorage.setItem(config.adminWalletAddressKey, setacc);
      localStorage.setItem(config.walletType, "metamask");
      dispatch({
        type: Account_Connect,
        Account_Detail: {
          UserAccountAddr: setacc,
          WalletConnected: "true",
          Accounts: setacc,
          providerss: provider,
          networkConfiguration: configdata || {},
          web3,
        },
      });
    } catch (errr) {
      console.error("getConnect_error", errr);
      toast.error(errr?.message || "Unable to connect the browser wallet");
    }
  };

  const onChangeFUnc = async (e) => {
    var val = e.target.id;

    setServiceDisable("start");
    switch (val) {
      case "servicefeecheck1":
        if (e.target.value < 10 || e.target.value >= 0) {
          set_seller__fee(e.target.value);
        } else {
          set_seller__fee(0);
          setServiceDisable1("error");
        }
        break;
      case "servicefeecheck":
        if (e.target.value < 10 || e.target.value >= 0) {
          set_buyer__fee(e.target.value);
        } else {
          set_buyer__fee(0);
          setServiceDisable1("error");
        }
        break;
      case "servicefeecheck2":
        if (e.target.value < 10 || e.target.value >= 0) {
          set_minting_fee(e.target.value);
        } else {
          set_minting_fee(0);
          setServiceDisable1("error");
        }
        break;
      case "servicefeecheck3":
        if (e.target.value < 10 || e.target.value >= 0) {
          set_listing__fee(e.target.value);
        } else {
          set_listing__fee(0);
          setServiceDisable1("error");
        }
        break;
      case "servicefeecheck4":
        if (e.target.value < 10 || e.target.value >= 0) {
          set_withdraw__fee(e.target.value);
        } else {
          set_withdraw__fee(0);
          setServiceDisable1("error");
        }
        break;
    }
  };
  const serfeeall = () => {
    setmodalopen(true);
  };

  const handleSubmit = async () => {
    if (!submitdisable) {
      SetSubmitDisable(true);
      let id = toast.loading("Processing...");
      try {
        const walletProvider = Wallet_Details.providerss || window.ethereum;
        if (!walletProvider) {
          throw new Error("No connected wallet provider is available");
        }
        var web3 = new Web3(walletProvider);
        const IDcheck = parseInt(await web3.eth.getChainId());

        if (Number(IDcheck) === Wallet_Details.networkConfiguration.Chainid) {
          var curradd = Wallet_Details.UserAccountAddr.toLowerCase();
          if (!Wallet_Details.UserAccountAddr) {
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "please connect wallet",
              type: "warning",
              isLoading: false,
              autoClose: 1000,
            });
          } else if (curradd != owner_Get) {
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "only Admin can edit service fee",
              type: "warning",
              isLoading: false,
              autoClose: 1000,
            });
          }

          var errors = {};

          if (buyer__fee == "") {
            errors.buyerFee = "Buyer Fee cannot be empty";
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "Buyer Fee cannot be empty",
              type: "error",
              isLoading: false,
              autoClose: 1000,
            });
          }

          if (seller__fee == "") {
            errors.sellerFee = "Seller Fee cannot be empty";
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "Seller Fee cannot be empty",
              type: "error",
              isLoading: false,
              autoClose: 1000,
            });
          }

          if (minting_fee == "") {
            errors.mintingFee = "Minting Fee cannot be empty";
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "Minting Fee cannot be empty",
              type: "error",
              isLoading: false,
              autoClose: 1000,
            });
          }

          if (listing__fee == "") {
            errors.listingFee = "Listing Fee cannot be empty";
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "Listing Fee cannot be empty",
              type: "error",
              isLoading: false,
              autoClose: 1000,
            });
          }

          if (withdraw__fee == "") {
            errors.withdrawFee = "Withdraw Fee cannot be empty";
            SetSubmitDisable(false);
            return toast.update(id, {
              render: "Withdraw Fee cannot be empty",
              type: "error",
              isLoading: false,
              autoClose: 1000,
            });
          }

          if (Object.keys(errors).length == 0) {
            var payload = {
              buyerFee: buyer__fee,
              sellerFee: seller__fee,
              mintingFee: minting_fee,
              listingFee: listing__fee,
              withdrawFee: withdraw__fee,
            };

            if (payload) {
              var resp = await SetServiceFee(payload, id);
              console.log("🚀 ~ handleSubmit ~ resp:", resp);

              if (resp === true) {
                toast.update(id, {
                  render: "Service Fee updated Successfully",
                  type: "success",
                  isLoading: false,
                  autoClose: 1000,
                });
                setTimeout(() => {
                  GetContractServiceFee();
                }, 5000);
              } else {
                toast.update(id, {
                  render: "Please try again",
                  type: "error",
                  isLoading: false,
                  autoClose: 1000,
                });
              }
            }
          }
        }
      } catch (err) {
        console.error("handleSubmit_error", err);
        toast.update(id, {
          render: err?.message || "Unable to update the service fee",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
      SetSubmitDisable(false);
    }
  };

  const SetServiceFee = async (data, id) => {
    var web3 = new Web3(Wallet_Details.providerss);

    var payload = null;

    if (data) {
      payload = {
        buyerFee: web3.utils.toWei(String(data.buyerFee).trim(), "ether"),
        sellerFee: web3.utils.toWei(String(data.sellerFee).trim(), "ether"),
        mintingFee: web3.utils.toWei(String(data.mintingFee).trim(), "ether"),
        listingFee: web3.utils.toWei(String(data.listingFee).trim(), "ether"),
        withdrawFee: web3.utils.toWei(String(data.withdrawFee).trim(), "ether"),
      };
    }

    try {
      var Contract = await new web3.eth.Contract(
        Market,
        Wallet_Details.networkConfiguration.TradeContract,
      );

      let encoded = await Contract.methods.setServiceValue(
        SelectedServiceFee?.key,
        [
          payload.buyerFee,
          payload.sellerFee,
          payload.mintingFee,
          payload.withdrawFee,
          payload.listingFee,
        ],
      );

      var gasfeecalculated = await NewGetGasFees({
        web3: web3,
        contractcall: encoded,
        accountAddress: Wallet_Details.UserAccountAddr,
      });

      var resp = await Contract.methods
        .setServiceValue(SelectedServiceFee?.key, [
          payload.buyerFee,
          payload.sellerFee,
          payload.mintingFee,
          payload.withdrawFee,
          payload.listingFee,
        ])
        .send({
          from: Wallet_Details.UserAccountAddr,
          //   gasLimit: parseInt(gasfeecalculated?.gasdata * 1.5, 10),
          //   gasPrice: gasfeecalculated?.gasPrice,
        })
        .then(async () => {
          setServiceDisable1("done");
          if (ServiceDisable2 != "done") {
            setServiceDisable2("kk");
          }
          if (ServiceDisable3 != "done") {
            setServiceDisable3("kk");
          }
          let resp = await Contract.methods
            .FeeType(SelectedServiceFee?.key)
            .call();
          var feeDetails = {
            buyerFee: web3.utils.fromWei(
              String(resp?.buyerFees),
              "ether",
            ),
            sellerFee: web3.utils.fromWei(
              String(resp?.sellerFees),
              "ether",
            ),
            mintingFee: web3.utils.fromWei(
              String(resp?.mintFees),
              "ether",
            ),
            listingFee: web3.utils.fromWei(
              String(resp?.listFees),
              "ether",
            ),
            withdrawFee: web3.utils.fromWei(
              String(resp?.withdrawFees),
              "ether",
            ),
            // royaltyFee: web3.utils.fromWei(String(Number(resp[2]))),
          };

          if (feeDetails) {
            set_buyer__fee(feeDetails.buyerFee);
            set_seller__fee(feeDetails.sellerFee);
          }

          // set_default_service_fee721(servicefee / 1e18)
          setServiceDisable1("done");
        })
        .catch((err) => {
          console.error("setServiceValue_error", err);
          setServiceDisable1("try");
        });
      if (resp) return true;
    } catch (err) {
      console.error("SetServiceFee_error", err);
    }

    if (resp) {
      toast.success("service fee updated successfully!");
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    }
  };

  const disconnect = () => {
    Set_Accounts("");
    localStorage.removeItem(config.adminWalletAddressKey);
  };

  const changeNetwork = async () => {
    SetSubmitDisable(true);
    try {
      const provider = Wallet_Details.providerss
        || (typeof window !== "undefined" ? window.ethereum : null);
      const currentChainId = await readProviderChainId(provider);
      const targetNetwork = nextAdminNetwork(currentChainId, network);
      if (!targetNetwork) throw new Error("No supported network is configured");

      const switchedChainId = await switchProviderNetwork(provider, targetNetwork);
      const networkConfiguration = networkForChainId(switchedChainId, network);
      if (!networkConfiguration) {
        throw new Error("The wallet switched to an unsupported network");
      }

      const web3 = new Web3(provider);
      const accounts = await web3.eth.getAccounts();
      const account = accounts?.[0]?.toLowerCase();
      if (!account) throw new Error("The wallet did not return a connected account");

      Set_Accounts(account);
      SetCurrentChainId(switchedChainId);
      setContractReadError("");
      dispatch({
        type: Account_Connect,
        Account_Detail: {
          UserAccountAddr: account,
          WalletConnected: "true",
          Accounts: account,
          providerss: provider,
          networkConfiguration,
          web3,
        },
      });
      toast.success(`Network switched to ${networkConfiguration.name}`);
    } catch (error) {
      console.error("changeNetwork_error", error);
      toast.error(error?.message || "Unable to switch the wallet network");
    } finally {
      SetSubmitDisable(false);
    }
  };

  const GetServiceFeeOrder = async () => {
    let senddata = { type: "get" };
    let Resp = await ServiceFeeaction(senddata);
    console.log("🚀 ~ GetServiceFeeOrder ~ Resp:", Resp, Resp?.data?.[0]);
    SetServiceFeeOption(Resp?.data ?? []);
    SetSelectedServiceFee(Resp?.data?.[0]);
  };

  useEffect(() => {
    if (!isEmpty(SelectedServiceFee)) {
      GetContractServiceFee();
    }
  }, [SelectedServiceFee]);

  const GetContractServiceFee = async () => {
    if (Wallet_Details?.networkConfiguration?.TradeContract) {
      try {
        setContractReadError("");
        var web3 = new Web3(Wallet_Details.networkConfiguration.BNBPROVIDER);
        var Contract = new web3.eth.Contract(
          Market,
          Wallet_Details.networkConfiguration.TradeContract,
        );
        console.log(
          "Wallet_Details.networkConfiguration.TradeContract-->",
          Wallet_Details.networkConfiguration.TradeContract,
        );
        var ownerGet = await Contract.methods.owner().call();
        var ownget = String(ownerGet).toLowerCase();

        set_Owner_Get(ownget);
        //  _fees[0] - serviceValue, _fees[1] - sellervalue, _fees[2] - Minting Fees, _fees[3] -  Listing Fee, _fees[4] - Withdrawal Fee
        var resp = await Contract.methods
          .FeeType(SelectedServiceFee?.key)
          .call();
        console.log("🚀 ~ GetContractServiceFee ~ resp:", resp);
        if (resp) {
          var feeDetails = {
            buyerFee: web3.utils.fromWei(
              String(resp?.buyerFees),
              "ether",
            ),
            sellerFee: web3.utils.fromWei(
              String(resp?.sellerFees),
              "ether",
            ),
            mintingFee: web3.utils.fromWei(
              String(resp?.mintFees),
              "ether",
            ),
            listingFee: web3.utils.fromWei(
              String(resp?.listFees),
              "ether",
            ),
            withdrawFee: web3.utils.fromWei(
              String(resp?.withdrawFees),
              "ether",
            ),
          };
          if (feeDetails) {
            set_buyer__fee(feeDetails.buyerFee);
            set_seller__fee(feeDetails.sellerFee);
            set_minting_fee(feeDetails.mintingFee);
            set_listing__fee(feeDetails.listingFee);
            set_withdraw__fee(feeDetails.withdrawFee);
          }
        }
      } catch (err) {
        console.error("GetContractServiceFee_error", err);
        setContractReadError(
          "Unable to read the marketplace owner and service fees from this network.",
        );
      }
    }
  };

  const NewGetGasFees = async (data) => {
    try {
      var { web3, contractcall, value, accountAddress } = data;
      var gasPrice = await web3.eth.getGasPrice();

      var gasdata;
      if (value) {
        gasdata = await contractcall.estimateGas({
          from: accountAddress,
          value: value,
        });
      } else {
        gasdata = await contractcall.estimateGas({
          from: accountAddress,
        });
      }

      return {
        gasdata: web3.utils.toHex(gasdata),
        gasPrice: web3.utils.toHex(gasPrice),
      };
    } catch (err) {
      console.error("NewGetGasFees_errorrr", err);
      return undefined;
    }
  };

  const displayedNetwork = networkForChainId(currentChainId, network);
  const networkHeading = isEmpty(currentChainId)
    ? "No Address Connected"
    : displayedNetwork
      ? `${displayedNetwork.name} Network`
      : `Unsupported Wallet Network (${currentChainId})`;

  return (
    <Layout>
      <div className="servicefeeedit">
        <div className="text-end">
          {Accounts == "" ? (
            <>
              <Link
                onClick={() => getConnect()}
                to="#"
                className="btn sitebtn mb-4 py-2 px-3 me-2"
              >
                Mobile Wallets
              </Link>
              <Link
                onClick={() => getMetamask()}
                to="#"
                className="btn sitebtn mb-4 py-2 px-3"
              >
                Metamask
              </Link>
            </>
          ) : (
            <>
              <Link
                onClick={() => disconnect()}
                to="#"
                className="btn sitebtn mb-4 py-2 px-3"
              >
                {Accounts}
              </Link>
            </>
          )}
        </div>

        <div className="cardbox">
          <h5 className="pageboxhead">
            {networkHeading}
          </h5>

          {Accounts ? (
            <></>
          ) : (
            <h5 className="pageboxhead text-danger">
              Please connect wallet to view service fee
            </h5>
          )}

          {Accounts && (
            <div className="text-end">
              <button
                className="btn sitebtn mb-4 py-2 px-3"
                type="button"
                disabled={submitdisable}
                onClick={() => changeNetwork()}
              >
                switch network
              </button>
            </div>
          )}
          {/* <Select
            options={ServiceFeeOptions}
            // defaultValue={SelectedServiceFee}
            isDisabled={true}
            value={SelectedServiceFee}
            onChange={(e) => SetSelectedServiceFee(e)}
            className="mb-4"
          /> */}
          <Form>
            <Row>
              <Col xs={12} sm={12} md={12} xl={6} className="mb-3">
                <div className="servicemodflex">
                  <div className="servicemod">
                    <p className="text-center">Buyer Fee- {buyer__fee}%</p>
                    <p className="text-center">Seller Fee- {seller__fee}%</p>
                    <p className="text-center">Minting Fee- {minting_fee}</p>
                    <p className="text-center">Listing Fee- {listing__fee}</p>
                    <p className="text-center">Withdraw Fee- {withdraw__fee}</p>
                    <p className="text-center servicefeecont">
                      Service fees in 721
                    </p>
                  </div>
                  <div className="servicemod">
                    <p className="text-center">Buyer Fee- {buyer__fee}%</p>
                    <p className="text-center">Seller Fee- {seller__fee}%</p>
                    <p className="text-center">Minting Fee- {minting_fee}</p>
                    <p className="text-center">Listing Fee- {listing__fee}</p>
                    <p className="text-center">Withdraw Fee- {withdraw__fee}</p>
                    <p className="text-center servicefeecont">
                      Service fees in 1155
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} xl={6} className="mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>Buyer Service Fee</Form.Label>
                  <Form.Control
                    id="servicefeecheck"
                    value={buyer__fee || ""}
                    onChange={(e) => onChangeFUnc(e)}
                    type="text"
                  />
                </Form.Group>
                {buyer__fee == "" && (
                  <span className="text-danger">Check service fee</span>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Seller Service Fee</Form.Label>
                  <Form.Control
                    id="servicefeecheck1"
                    value={seller__fee || ""}
                    onChange={(e) => onChangeFUnc(e)}
                    type="text"
                  />
                </Form.Group>
                {seller__fee == "" && (
                  <span className="text-danger">Check service fee</span>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Minting Fee</Form.Label>
                  <Form.Control
                    id="servicefeecheck2"
                    value={minting_fee || ""}
                    onChange={(e) => onChangeFUnc(e)}
                    type="text"
                  />
                </Form.Group>
                {minting_fee == "" && (
                  <span className="text-danger">Check minting fee</span>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Listing Fee</Form.Label>
                  <Form.Control
                    id="servicefeecheck3"
                    value={listing__fee || ""}
                    onChange={(e) => onChangeFUnc(e)}
                    type="text"
                  />
                </Form.Group>
                {listing__fee == "" && (
                  <span className="text-danger">Check listing fee</span>
                )}
                <Form.Group>
                  <Form.Label>Withdraw Fee</Form.Label>
                  <Form.Control
                    id="servicefeecheck4"
                    value={withdraw__fee || ""}
                    onChange={(e) => onChangeFUnc(e)}
                    type="text"
                  />
                </Form.Group>
                {withdraw__fee == "" && (
                  <span className="text-danger">Check withdraw fee</span>
                )}
              </Col>
            </Row>
          </Form>
          {Accounts && (
            <div className="text-end">
              <button
                type="button"
                className="btn sitebtn mb-2 py-2 px-3"
                disabled={
                  submitdisable ||
                  !owner_Get ||
                  Accounts.toLowerCase() !== owner_Get.toLowerCase()
                }
                onClick={() => handleSubmit()}
              >
                Edit Service Fee
              </button>
              {owner_Get && Accounts.toLowerCase() !== owner_Get.toLowerCase() && (
                <p className="text-danger mb-2">
                  Connect the marketplace owner wallet {owner_Get} to edit fees.
                </p>
              )}
              {contractReadError && (
                <p className="text-danger mb-2">{contractReadError}</p>
              )}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ServiceFeeEdit;
